export const SOCKET_TIMOUT = 30000;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/constants/socket-timeout.ts